import React, { useState, useEffect } from "react";
import HorizontalBarChart from "../Charts/HorizontalBarChart";
import AreaChart from "../Charts/AreaChart";
import directoryServices from "../directories/directoryServices";
import { CommonUtilities } from "../../commonUtils";
import { format } from "date-fns";
import PeriodSelectionForm from "../PeriodSelection/periodSelectionForm";
import ContainerSlider from "./Analytic/ContainerSlider";
import { Filter } from "../../filter";
import ContainerServices from "../container/containerServices";
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import cachingMechanisum from "../Common/cachingMechanisum";

export default function Summary(param: any) {

    let [sumGross, setSumGross] = useState(0);
    let [searchFor, setsearchFor] = useState("");
    let [sumPaidOut, setSumPaidOut] = useState(0);
    let [TEtotalRow, setTETotalRows] = useState(0);
    let [reportingTo, setreportingTo] = useState("");
    let [TAStotalRow, setTASTotalRows] = useState(0);
    let [TATtotalRow, setTATTotalRows] = useState(0);
    let [TETfotalRows, setTETfotalRows] = useState(0);
    let [reportingFrom, setreportingFrom] = useState("");
    let [TopImpCusRows, setTopImpCusRows] = useState(0);
    let [DSPSummay, setDSPSummay] = useState<any>([]);
    let [activeAllTime, setActiveAllTime] = useState(0);
    let [criterias, setCriterias] = useState<any>([]);
    let [containerType, setcontainerType] = useState<any>([]);
    let [transactionRef, settransactionRef] = useState("");
    let [summaryList, setSummaryList] = useState<any>([]);
    let [AssetSummay, setAssetSummay] = useState<any>([]);
    let [ArtistSummay, setArtistSummay] = useState<any>([]);
    let [FormatSummay, setFormatSummay] = useState<any>([]);
    let [ImprintSummay, setImprintSummay] = useState<any>([]);
    let [periodSelection, setperiodSelection] = useState(false);
    let [dialogueOpenView, setdialogueOpenView] = useState(false);
    let [DSPGraphSummay, setDSPGraphSummay] = useState<any>([]);
    let [TerritorySummay, setTerritorySummay] = useState<any>([]);
    let [allDataSummary, setAllDataSummary] = useState<any>([]);
    let [activePerformanceTab, setactivePerformanceTab] = useState("Performance");


    let [totalArtist, SETtotalArtist] = useState(0);
    let [totalAssets, SETtotalAssets] = useState(0);
    let [totalTerritory, SETtotalTerritory] = useState(0);
    let [totalFormats, SETtotalFormats] = useState(0);
    let [totalImprints, SETtotalImprints] = useState(0);
    let [totalDSP, SETtotalDSP] = useState(0);
    let [periodSelected, SetperiodSelected] = useState<any>([]);
    let [clientDetailList, setclientDetailList] = useState<any>([]);

    useEffect(() => {
        clientDetailList = cachingMechanisum.getCachingStorage("ClientDetails");
        setclientDetailList(clientDetailList)

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        //console.log(periodListCache)
        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }

        console.log("period_1")
        if (!Filter.DateTimeFormatNumber(periodSelected?.periodFrom)) {
            setreportingFrom("20260131")
        } else {
            setreportingFrom(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)));
        }


        if (!Filter.DateTimeFormatNumber(periodSelected?.periodTo)) {
            setreportingTo("20260131")
        } else {
            setreportingTo(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)));
        }


        if (param && param.summaryPayload) {

            if (param?.summaryPayload?.periodFrom) {
                reportingFrom = param?.summaryPayload?.periodFrom;
                setreportingFrom(reportingFrom);
            }

            if (param?.summaryPayload?.periodTo) {
                reportingTo = param?.summaryPayload?.periodTo;
                setreportingTo(reportingTo);
            }

            if (param?.summaryPayload?.transaction_Ref) {
                transactionRef = param?.summaryPayload?.transaction_Ref
                settransactionRef(transactionRef);
                pagination.transaction_Ref = param?.summaryPayload?.transaction_Ref
            }

            if (param?.summaryPayload?.criteriaList) {
                criterias = param?.summaryPayload?.criteriaList
                setCriterias(criterias);
                setcontainerType([]);

                for (var $i = 0; $i < criterias.length; $i++) {

                    var temp = containerType?.filter((containerTypeItem: any) => containerTypeItem === criterias[$i].containerType);
                    if (temp.length === 0) {
                        containerType.push(criterias[$i].containerType);
                    }
                }

                setcontainerType(containerType)
            }
        }
        const modal = document.getElementById("myModal");

        const session = JSON.parse(sessionStorage.getItem("applicationSession") || "{}");
        if (modal !== null && session?.activeMenu != "Chart Summary") {
            console.log("Modal exists in DOM");

            sessionStorage.setItem("modalTabOpen", JSON.stringify({ activeMenu: "Chart Summary" }));
            ApiCall("TopALL");
        } else {
            console.log("Modal not found");
        }

    }, [])

    var pagination = {
        pageSize: 10,
        pageNumber: 1,
        type: "",
        transaction_Ref: transactionRef,
        periodTo: reportingTo,
        periodFrom: reportingFrom,
        Section: activePerformanceTab,
        searchFor: searchFor,
        activeAllTime: activeAllTime
    }

    const ApiCall = (type: any) => {
        CommonUtilities?.BtnLoading("searchSummary");
        pagination = { ...pagination, ...param.code }

        if (periodSelected?.periodFrom && Filter.DateTimeFormatNumber(periodSelected?.periodFrom)) {
            pagination.periodFrom = reportingFrom && reportingFrom.length > 0 ? reportingFrom : String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom));
        } else {
            pagination.periodFrom = reportingFrom && reportingFrom.length > 0 ? reportingFrom : "20260630";
        }

       if (periodSelected?.periodTo && Filter.DateTimeFormatNumber(periodSelected?.periodTo)) {
            pagination.periodTo = reportingTo && reportingTo.length > 0 ? reportingTo : String(Filter.DateTimeFormatNumber(periodSelected?.periodTo));
        } else {
            pagination.periodTo = reportingTo && reportingTo.length > 0 ? reportingTo : "20260630";
        } 

        console.log(Filter.DateTimeFormatNumber(periodSelected?.periodTo))
        console.log(!Filter.DateTimeFormatNumber(periodSelected?.periodTo))

        setAllDataSummary([]);
        setDSPGraphSummay([]);
        setFormatSummay([]);
        setImprintSummay([]);
        setAssetSummay([]);
        setArtistSummay([]);
        setTerritorySummay([]);
        DSPSummay = [];
        setDSPSummay(DSPSummay);
        sumGross = 0
        sumPaidOut = 0
        setSumGross(sumGross);
        CommonUtilities?.blockUiLoading(true);

        let cacheFound = null
        cachingMechanisum.readFromStoredCacheKey(pagination, 'SinglePageSummary').then((res: any) => {
            cacheFound = res;
            console.log(cacheFound);

            if (res) {
                dataAssignment(res);
                CommonUtilities.blockUiLoading(false);
            }

            if (!res) {
                directoryServices.singlePageSummaryListing(pagination).then((res: any) => {
                    dataAssignment(res);
                    cachingMechanisum.analyticCacheBuild(pagination, res, "SinglePageSummary");
                });
            }
        });

        var payload = { ...pagination, criteriaList: criterias }
        param?.onChangeSummary(payload);
    }


    const dataAssignment = (res: any) => {
        setAllDataSummary(res);

        summaryList = res.filter((data: any) => data.type === "TopPeriod");

        setSummaryList(summaryList.sort((a: any, b: any) => a.totalGross > b.totalGross ? 1 : -1));

        for (var $i = 0; $i < summaryList.length; $i++) {
            sumGross = sumGross + summaryList[$i].totalGross
            setSumGross(sumGross);
            setSumPaidOut(sumPaidOut + summaryList[$i].totalPaidOut);
        }

        setTATTotalRows(res && res[0] && res[0]?.totalRows > 0 ? res[0]?.totalRows : 0);

        ArtistSummay = res.filter((data: any) => data.type === "TopArtist");
        setArtistSummay(ArtistSummay);
        SETtotalArtist(getTotalValue(ArtistSummay));

        AssetSummay = res.filter((data: any) => data.type === "TopAsset");
        setAssetSummay(AssetSummay);
        SETtotalAssets(getTotalValue(AssetSummay));

        ImprintSummay = res.filter((data: any) => data.type === "TopLabel");
        setImprintSummay(ImprintSummay);
        SETtotalImprints(getTotalValue(ImprintSummay));

        TerritorySummay = res.filter((data: any) => data.type === "TopTerritory");
        setTerritorySummay(TerritorySummay);
        SETtotalTerritory(getTotalValue(TerritorySummay));

        FormatSummay = res.filter((data: any) => data.type === "TopFormat");
        setFormatSummay(FormatSummay);
        SETtotalFormats(getTotalValue(FormatSummay));

        DSPSummay = res?.filter((data: any) => data.type === "TopAccount");
        setDSPSummay(DSPSummay);
        SETtotalDSP(getTotalValue(DSPSummay));

        DSPGraphSummay = res.filter((data: any) => data.type === "TopGraphAccount")
        setDSPGraphSummay(DSPGraphSummay);
    }

    const CallChart = (data: any, name: any) => {

        var backgroundColor: any = [];
        var percentageGross: any = [];
        var percentagePaidOut: any = [];
        var labelsData: any = [];
        var xName = 'value'
        var yName = 'Code'
        for (var i = 0; i < data?.length; i++) {
            percentageGross.push(data[i].totalGross.toFixed(2));
            percentagePaidOut.push(data[i].totalPaidOut.toFixed(2));
            if (name === "Period") {
                labelsData.push(data[i].royaltyPeriod)

            };

            if (name === "Asset") {
                yName = "Asset"
                labelsData.push(data[i].assetTitle);
            };

            if (name === "Artist") {
                yName = "Artist"
                labelsData.push(data[i].assetArtist);
            };

            if (name === "DSP") {
                labelsData.push(data[i].royaltyPeriod)
            };

            if (name === "Imprint") {
                yName = "Imprint"
                labelsData.push(data[i].assetImprint)
            };

            if (name === "Territory") {
                yName = "Territory"
                labelsData.push(data[i].territoryCode)
            };

            if (name === "Format") {
                yName = "Format"
                labelsData.push(data[i].formatCode)
            };

            for (var j = 0; j < CommonUtilities?.chartColors?.length; j++) {
                backgroundColor.push(CommonUtilities?.chartColors[j]);
            }
        }

        var scalesName = {
            x: {
                title: {
                    display: true,
                    text: xName,
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
            y: {
                title: {
                    display: true,
                    text: yName,
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
        }

        const options = {
            layout: { padding: { top: 0 } },
            plugins: { elements: { bar: { borderWidth: 0, }, } },
            scales: scalesName
        };


        var dataObj = {
            labels: labelsData,
            datasets: [
                {
                    label: 'Total Gross',
                    data: percentageGross,
                    borderColor: backgroundColor[1],
                    backgroundColor: backgroundColor[1],
                    yAxisID: 'y',
                }
            ]
        };

        return { options: options, data: dataObj };
    }

    const CallChartDSP = (data: any, name: any) => {

        var percentageGross: any = [];
        var labelsData: any = [];
        var datasets: any = [];
        var labelName: any = [];
        var topSelection: any = [];

        for (var i = 0; i < data?.length; i++) {
            if ((labelsData?.filter((e: any) => e === data[i].royaltyPeriod)).length === 0) {
                labelsData.push(data[i].royaltyPeriod);
            }
        }

        const sortedArray = [...labelsData].sort((a, b) => a - b);
        labelsData = []
        labelsData = sortedArray

        for (var i = 0; i < DSPSummay?.length; i++) {
            if ((labelName?.filter((e: any) => e === DSPSummay[i].subProvider?.toLocaleLowerCase())).length === 0) {

                labelName.push(DSPSummay[i].subProvider?.toLocaleLowerCase());
            }
        }

        for (var y = 0; y < labelName?.length; y++) {
            percentageGross = []
            for (var i = 0; i < labelsData?.length; i++) {
                const sumtotalGross = data?.filter((e: any) => e.subProvider?.toLocaleLowerCase() === labelName[y] && e.royaltyPeriod === labelsData[i]);
                percentageGross.push(sumtotalGross[0] && sumtotalGross[0].totalGross ? sumtotalGross[0].totalGross.toFixed(2) : 0)
            }

            const color = CommonUtilities?.getDSPColor(labelName[y]);

            const safeColor =
                typeof color === "string"
                    ? color
                    : "#999999";

            datasets.push({
                label: CommonUtilities?.headerName(labelName[y]),
                data: percentageGross,
                borderColor: safeColor,
                backgroundColor: safeColor,
                yAxisID: "y",
            });

        }

        const options = {
            layout: { padding: { top: 0 } },
            plugins: {
                elements:
                {
                    bar:
                        { borderWidth: 0, },
                }
            },
            interaction: { mode: 'index', intersect: false, },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'Period',
                        font: {
                            size: 14,
                            weight: 'bold',
                        },
                    },
                },
                y: {
                    title: {
                        display: true,
                        text: 'Value',
                        font: {
                            size: 14,
                            weight: 'bold',
                        },
                    },
                },
            },
            tension: 0.4,
        };

        for (var y = 0; y < datasets?.length; y++) {
            if (y < 5) {
                topSelection.push(datasets[y]);
            }
        }

        var dataObj = { labels: labelsData, datasets: topSelection };

        return { options: options, data: dataObj };
    }

    const closePeriod = (e: any) => {
        periodSelection = false;
        setperiodSelection(false)
    }

    const getTotalValue = (param: any) => {

        var total = 0;
        for (var $i = 0; $i < param.length; $i++) {
            total = total + param[$i].totalGross;
        }

        return total;
    }

    const periodValidation = () => {

        console.log(pagination);

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");

        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }

        if (pagination.periodFrom.length !== 8) {

            setreportingFrom(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)));
        }

        if (pagination.periodTo.length !== 8) {

            setreportingTo(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)));
        }
    }

    const onChange = (period: any) => {
        console.log(period);

        const isFirefox = navigator.userAgent
            .toLowerCase()
            .includes("firefox");

        if (isFirefox) {
            firefoxOnChange(period);
        } else {
            chromeOnChange(period);
        }
    };

    const chromeOnChange = (period: any) => {
        if (period.periodFrom) {
            const value = period.periodFrom.year + format(new Date(period.periodFrom.month), "MMdd");
            pagination.periodFrom = value;
            reportingFrom = value;
            setreportingFrom(value);
        }

        if (period.periodTo) {
            const value = period.periodTo.year + format(new Date(period.periodTo.month), "MMdd");
            pagination.periodTo = value;
            reportingTo = value;
            setreportingTo(value);
        }

        if (period?.action === 2) {
            ApiCall("TopALL");
        }

        periodValidation();
    };

    const firefoxOnChange = (period: any) => {
        if (period.periodFrom) {
            const value = getFirefoxDate(period.periodFrom);

            pagination.periodFrom = value;
            reportingFrom = value;
            setreportingFrom(value);
        }

        if (period.periodTo) {
            const value = getFirefoxDate(period.periodTo);

            pagination.periodTo = value;
            reportingTo = value;
            setreportingTo(value);
        }

        if (period?.action === 2) {
            ApiCall("TopALL");
        }

        periodValidation();
    };

    const getFirefoxDate = (date: any) => {
        const months: Record<string, string> = {
            January: "01",
            February: "02",
            March: "03",
            April: "04",
            May: "05",
            June: "06",
            July: "07",
            August: "08",
            September: "09",
            October: "10",
            November: "11",
            December: "12",
        };

        const monthName = date.month.split(" ")[0];

        return `${date.year}${months[monthName]}01`;
    };


    const onChangeClose = (e: any) => {
        //console.log(e)
        if (e && e.action === 'search') {
            setcontainerType([])
            pagination.transaction_Ref = e.tranRef;
            settransactionRef(e.tranRef);

            criterias = e?.containerSet
            setCriterias(criterias)

            for (var $i = 0; $i < e?.containerSet.length; $i++) {

                var temp = containerType?.filter((containerTypeItem: any) => containerTypeItem === e?.containerSet[$i].containerType);
                //console.log(temp)
                //console.log(temp.length)
                if (temp.length === 0) {
                    containerType.push(e?.containerSet[$i].containerType);
                }
            }

            setcontainerType(containerType)

            ApiCall("TopALL");
        }

        if (e && e.action === 'Close') {
            console.log("Close")
        }
        setdialogueOpenView(false);
    }

    const paginationTE = (e: any) => {
        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;
        ApiCall("TopExtract");
    }

    const paginationTAS = (e: any) => {
        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;
        ApiCall("TopAssets");
    }

    const paginationTAT = (e: any) => {
        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;
        ApiCall("TopArtists");
    }

    const tabChange = (e: any, allTime: any) => {

        if (allTime !== allTime) {
            cachingMechanisum.analyticCacheBuildDel(pagination, "SinglePageSummary");
        }
        console.log(allTime)
        activeAllTime = allTime
        setActiveAllTime(activeAllTime);

        setactivePerformanceTab(e);
        sumGross = 0
        sumPaidOut = 0
        setSumGross(sumGross);
        setSumPaidOut(sumPaidOut);
        pagination.Section = e;
        ApiCall("TopALL");
    }

    const paginationTIC = (e: any) => {
        //console.log(e)
        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;
        if (e === 'Financial') {
            ApiCall("TopImpCus");
        }
    }

    const paginationTTF = (e: any) => {
        //console.log(e)
        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;
        ApiCall("TopTerritoryFormat");
    }

    const searchSummary = (e: any) => {
        setsearchFor(e);
        ApiCall("TopALL");
    }

    const downloadSummary = (type: any) => {
        //console.log(type)
        console.log(pagination)

        pagination.type = type;
        var payload = {}

        if (param && param.code) {
            payload = { ...pagination, exportType: "exportType", ...param.code }
        }

        if (param && !param.code) {
            payload = { ...pagination, exportType: "exportType" }
        }


        console.log(payload)
        directoryServices.excelGenericExport(payload);
        CommonUtilities?.BtnLoading(type);

        setTimeout(function () {
            CommonUtilities?.RemoveBtnLoading(type);
        }, 5000);

    }

    const removeContainerCode = () => {
        transactionRef = "";
        pagination.transaction_Ref = ""
        settransactionRef(transactionRef);
        ApiCall("TopALL");
    }

    const removeTag = (tag: any) => {
        //console.log(tag)
        if (tag && tag.transContainersId) {
            ContainerServices.UnlinkContainer(tag.transContainersId).then((values) => {

                ApiCall("TopALL");
            })
            setCriterias(criterias.filter((value: any) => value.containerCode !== tag.containerCode))

            cachingMechanisum.analyticCacheBuildDel(pagination, "SinglePageSummary");
        }
    }

    var options = [10, 20, 50, 100];


    let [TopAssetSelection, setTopAssetSelection] = useState(0);
    let [TopArtistSelection, setTopArtistSelection] = useState(0);
    let [TopTerritorySelection, setTopTerritorySelection] = useState(0);
    let [TopFormatSelection, setTopFormatSelection] = useState(0);
    let [TopImprintSelection, setTopImprintSelection] = useState(0);
    let [TopDSPSelection, setTopDSPSelection] = useState(0);

    const pagsizeUpdate = (value: any, type: any) => {
        console.log(type);
        console.log(value);
        console.log(pagination);

        var finalpag = { ...pagination }
        finalpag.type = type
        finalpag.pageSize = value

        directoryServices.singlePageSummaryListing(finalpag).then((res: any) => {

            CommonUtilities?.RemoveBtnLoading("searchSummary");
            CommonUtilities?.blockUiLoading(false);

            if (type === "TopArtist") {
                TopArtistSelection = value
                setTopArtistSelection(TopArtistSelection)
                ArtistSummay = res.filter((data: any) => data.type === "TopArtist");
                setArtistSummay(ArtistSummay);
                SETtotalArtist(getTotalValue(ArtistSummay));
            }

            if (type === "TopAsset") {
                TopAssetSelection = value
                setTopAssetSelection(TopAssetSelection)
                AssetSummay = res.filter((data: any) => data.type === "TopAsset");
                setAssetSummay(AssetSummay);
                SETtotalAssets(getTotalValue(AssetSummay));
            }

            if (type === "TopLabel") {
                TopImprintSelection = value
                setTopImprintSelection(TopImprintSelection)
                ImprintSummay = res.filter((data: any) => data.type === "TopLabel");
                setImprintSummay(ImprintSummay);
                SETtotalImprints(getTotalValue(ImprintSummay));
            }

            if (type === "TopTerritory") {
                TopTerritorySelection = value
                setTopTerritorySelection(TopTerritorySelection)
                TerritorySummay = res.filter((data: any) => data.type === "TopTerritory");
                setTerritorySummay(TerritorySummay);
                SETtotalTerritory(getTotalValue(TerritorySummay));
            }

            if (type === "TopFormat") {
                TopFormatSelection = value
                setTopFormatSelection(TopFormatSelection)
                FormatSummay = res.filter((data: any) => data.type === "TopFormat");
                setFormatSummay(FormatSummay);
                SETtotalFormats(getTotalValue(FormatSummay));
            }

            if (type === "TopAccount") {
                TopDSPSelection = value
                setTopDSPSelection(TopDSPSelection)
                DSPSummay = res?.filter((data: any) => data.type === "TopAccount");
                setDSPSummay(DSPSummay);
                SETtotalDSP(getTotalValue(DSPSummay));
            }

        });
    }

    return (<>
        <div className='ws-12 ptl'>
            <div className="ws-12 mbl pr">
                <div className="pull-left mrxl">
                    <a className={activePerformanceTab === 'Performance' ? 'icon-btn edit fill m0' : 'icon-btn edit m0'} onClick={() => { tabChange('Performance', activeAllTime); }}>Performance</a>
                    <a className={activePerformanceTab === 'Financial' ? 'icon-btn edit fill ' : 'icon-btn edit '} onClick={() => { tabChange('Financial', activeAllTime); }}>Royalties</a>
                </div>

                <div className="ws-4">
                    <button className="btn white bg-level7 p8 ws-3 m0 pull-right buttonLoad" id="searchSummary" onClick={() => searchSummary(searchFor)}> Search  </button>
                    <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="p7 ws-8 heightReset border-green pull-right" placeholder="Click search to show data " />
                </div>

                <button className="btn-queue pull-right m0" onClick={() => setdialogueOpenView(true)}>Filter </button>

                <div className="pull-right">
                    <div className="pull-left pull-right">
                        <div className="centerWindow ws-12">
                            <a className="icon-btn edit" onClick={() => setperiodSelection(true)}>
                                <i className="icon-angle-right text-m pull-right mll"></i>
                                <span className="pull-right success"> {Filter.NumToDate(reportingTo)}</span>
                                <i className="icon-vertical-line ml pull-right mr text-sl success"></i>
                                <span className="pull-right success">{Filter.NumToDate(reportingFrom)}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="pull-right pt mt mr">
                    <span className="pull-left mr"> All Time </span>
                    <label className="switch">
                        <input type="checkbox" checked={activeAllTime === 1 ? true : false} onClick={() => { tabChange(activePerformanceTab, activeAllTime === 1 ? 0 : 1) }} />
                        {activeAllTime === 1 && <span className="slider round text-left white pm pts">Yes</span>}
                        {activeAllTime === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                    </label>
                </div>

            </div>

            {(transactionRef?.length > 0) && <div className="ws-12 ptl mtl">
                <span className="text-bold pull-left mt hide">Container Code : </span>
                {
                    containerType?.map((value: any) => {

                        if ((criterias.filter((valueStored: any) => valueStored.containerType === value)).length > 0) {
                            return (

                                <div>
                                    <span className="text-bold pull-left mt ">{value} </span>

                                    {(() => {
                                        return (
                                            criterias?.map((values: any, index: any) => {

                                                if (values.containerType === value) {
                                                    return (
                                                        <a className="btn ms ps pull-left" style={{ background: CommonUtilities?.myArray[index], color: "RGB(255,255,255)" }}>
                                                            <span className="mrs mb white" >{values.containerCode}</span>

                                                            <span className="pull-right mtss white" onClick={() => removeTag(values)}>
                                                                <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                            </span>
                                                        </a>
                                                    )
                                                }

                                            })
                                        )

                                    })()}

                                </div>
                            )
                        }
                    })
                }
            </div>}

            <div className={allDataSummary?.length <= 0 ? 'ws-12 ptl mtl bgWhite full-height-vh90' : 'hide'}>
                <div className="ws-12">
                    <span className="text-center text-bold ws-12 mtl grey"> Not actioned. </span>
                </div>
            </div>

            <div className={allDataSummary?.length > 0 ? 'ws-12' : 'hide'}>
                {<div className="ws-12 mb p1 pr">
                    <h2 className={summaryList && summaryList?.length === 0 ? 'grey' : ''} >Income Analysis</h2>
                    <div className="box ws-12 pt pbl bgWhite overflowVisible">
                        {(summaryList?.length > 0) && <div className="ws-12">
                            <div className="prl pt pbl ws-12 ml">

                                <div className='ws-12 borderSolid pm'>

                                    <span className='ws-2 text-bold pull-left pull-left'>Income Summary</span>

                                    <div className="ws-10">
                                        <div className="ws-6">
                                            <span className='ws-6 pull-left success text-bold'> Total Gross : {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {sumGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(sumGross)}  </span>
                                            <span className='pull-right danger text-bold hide'>  Paid Out   : {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {sumPaidOut && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(sumPaidOut)} </span>
                                        </div>

                                        <div className="ws-6">

                                            {(summaryList?.length > 0) && <div className="ws-12 verticalMediumWide hover-box pull-right">
                                                <div className="ws-12 hover-block textboxDropdownList box defaultColor rightReset">
                                                    <div className="allowHscroll allowVscroll pm">
                                                        <div className="ws-12">
                                                            <span className='ws-6 text-bold pb'>Top Period</span>
                                                            <span className='pull-right icon-btn edit btn-xs m0 p0 buttonLoad' id="TopPeriod" onClick={() => downloadSummary("TopPeriod")}>
                                                                <i className="icon-download1 p1 m1"></i>
                                                            </span>
                                                        </div>

                                                        <span className='ws-4 pull-left pb pt'>Period</span>
                                                        <span className='ws-4 pull-right pb pt text-center hide'>PaidOut</span>
                                                        <span className='ws-4 pull-right pb pt text-center'>Gross</span>
                                                        {summaryList?.slice()
                                                            .sort((a: any, b: any) => {
                                                                if (a.totalGross < b.totalGross) return 1;
                                                                if (a.totalGross > b.totalGross) return -1;
                                                                return 0;
                                                            })?.map((value: any, index: any) => {
                                                                return (
                                                                    <div className='ws-12 box pm mb pull-right'>
                                                                        <span className='ws-4 pull-left text-bold' > {value.royaltyPeriod} </span>
                                                                        <span className='ws-4 pull-right text-center hide' style={{ color: "red" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalPaidOut?.toFixed(2)} </span>
                                                                        <span className='ws-4 pull-right text-center' style={{ color: "green" }}>    {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)} </span>
                                                                    </div>
                                                                )
                                                            })}

                                                        <div className="ws-12 pm">
                                                            <span className='ws-4 pull-left pb pt'>Total</span>
                                                            <span className='ws-4 pull-right pb pt text-center' style={{ color: "green" }}>
                                                                {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {sumGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(sumGross)}
                                                            </span>
                                                        </div>

                                                    </div>

                                                </div>

                                                <a className="icon-btn info pull-right noBorder p0"><i className="icon-info1 m0 p0"></i></a>
                                            </div>}
                                        </div>

                                    </div>
                                </div>

                                <div className="w-30 ptll hide" >
                                    {DSPSummay && DSPSummay?.map((value: any, index: any) => {

                                        if (index < 5) {
                                            return (
                                                <div className="ws-12 pm mt mb mt mb">

                                                    <div className="pull-left width90 text-center">
                                                        <img alt="Korrect" className="fillMaxWidth" height="44" src={"data:image/jpeg;base64," + value.dspImage} />

                                                    </div>
                                                    <div className="pull-left pll width190" style={{ borderLeft: 'solid 3px' + CommonUtilities?.getDSPColor(value.subProvider) }}>
                                                        <span className="text-bold pull-left text-xl mbl ws-12">{CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)} </span>
                                                        <span style={{ color: CommonUtilities?.getDSPColor(value.subProvider) }} className="pull-left">{value.subProvider}       </span>
                                                    </div>

                                                </div>)
                                        }
                                    })}
                                </div>

                                <div className='w-70 pull-right mtl pLarge hide'>
                                    <AreaChart chartPassedData={CallChartDSP(DSPGraphSummay, "DSP")} />
                                </div>
                            </div>
                        </div>}

                        {(summaryList && summaryList?.length === 0) && <div className="ws-12"><span className="text-center text-bold ws-12 mtl grey"> Not actioned. </span></div>}
                    </div>
                </div>}

                <div className="ws-12 mbl p1 prl">
                    <h2 className={DSPSummay && DSPSummay?.length === 0 ? 'grey' : ''}>Top

                        {DSPSummay && DSPSummay[0] && DSPSummay[0]?.totalRows > 10 && <span className="p1 ml mr">
                            <select value={TopDSPSelection} onChange={(e: any) => pagsizeUpdate(e.target.value, "TopGraphAccount")} className="dropDownListing p0 heightReset">
                                {options?.map((option: any) => (<option value={option}>{option}</option>))}
                            </select>
                        </span>}

                        {DSPSummay && DSPSummay[0] && DSPSummay[0]?.totalRows < 10 && <span> {DSPSummay[0]?.totalRows} </span>}

                        DSP
                    </h2>


                    {(DSPSummay.length > 0 || DSPGraphSummay.length > 0) && <div className='box pbl'>

                        {(DSPGraphSummay?.length > 0) && <div className="verticalMediumWide hover-box">
                            <div className="ws-6 mtxl ptl mll pll hover-block textboxDropdownList box defaultColor rightReset mr">
                                <div className="allowHscroll allowVscroll full-height-vh40">

                                    <div className="ws-12">
                                        <span className='ws-6 text-bold pb'>Top Dsp</span>
                                        <span className='pull-right icon-btn edit btn-xs m0 p0 mr buttonLoad' id="TopGraphAccount" onClick={() => downloadSummary("TopGraphAccount")}>
                                            <i className="icon-download1 p1 m1"></i>
                                        </span>
                                    </div>
                                    <span className='ws-6 pull-left pb pt'>Dsp Name</span>
                                    <span className='ws-3 pull-left pb pt'>Period</span>
                                    <span className='ws-3 pull-right pb pt text-center'>Gross</span>

                                    <div className="allowHscroll allowVscroll ws-12">
                                        {DSPGraphSummay?.map((value: any, index: any) => {
                                            return (
                                                <div className='ws-12 box pm mb pull-right'>
                                                    <span className='ws-6 text-bold purple' > {value.subProvider} </span>
                                                    <span className='ws-3 text-bold purple' > {value.royaltyPeriod} </span>
                                                    <span className='ws-3 pull-right text-center' style={{ color: "green" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)}  {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)}</span>
                                                    <span className='ws-3 pull-right hide' style={{ color: "red" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)}  {value.totalPaidOut?.toFixed(2)} </span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <div className="ws-12 pm">
                                        <span className='ws-9 pull-left pb pt'>Top {DSPGraphSummay?.length} Total</span>
                                        <span className='ws-3 pull-right pb pt text-center' style={{ color: "green" }}>
                                            {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {totalDSP && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalDSP)}
                                        </span>
                                    </div>

                                </div>

                            </div>

                            <a className="icon-btn info pull-right pt noBorder mt"><i className="icon-info1 m0 p0"></i></a>
                        </div>}

                        <div className="w-30 ptll" >
                            {DSPSummay && DSPSummay?.map((value: any, index: any) => {

                                if (index < 5) {
                                    return (
                                        <div className="ws-12 pm mt mb mt mb">

                                            <div className="pull-left width90 text-center">
                                                <img alt="Korrect" className="fillMaxWidth" height="44" src={CommonUtilities?.getdspImages(value?.subProvider, value).length === 0 ? korrectLogo : CommonUtilities?.getdspImages(value.subProvider, value)} />
                                            </div>
                                            <div className="pull-left pll width190" style={{ borderLeft: 'solid 3px' + CommonUtilities?.getDSPColor(value.subProvider) }}>
                                                <span className="text-bold pull-left text-xl mbl ws-12">{CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)} </span>
                                                <span style={{ color: CommonUtilities?.getDSPColor(value.subProvider) }} className="pull-left">{value.subProvider}       </span>
                                            </div>

                                        </div>)
                                }
                            })}
                        </div>

                        <div className='w-70 pull-right mtl pLarge'>
                            <AreaChart chartPassedData={CallChartDSP(DSPGraphSummay, "DSP")} />
                        </div>

                    </div>}
                </div>

                {<div className="ws-6 mbl p1 prl">
                    <h2 className={ArtistSummay && ArtistSummay?.length === 0 ? 'grey' : ''}>Top

                        {ArtistSummay && ArtistSummay[0] && ArtistSummay[0]?.totalRows > 10 && <span className="p1 ml mr">
                            <select value={TopArtistSelection} onChange={(e: any) => pagsizeUpdate(e.target.value, "TopArtist")} className="dropDownListing p0 heightReset">
                                {options?.map((option: any) => (<option value={option}>{option}</option>))}
                            </select>
                        </span>}

                        {ArtistSummay && ArtistSummay[0] && ArtistSummay[0]?.totalRows < 10 && <span> {ArtistSummay[0]?.totalRows} </span>}
                        Artist</h2>
                    <div className='box ws-12 pt pbl'>
                        <div className='ws-12'>

                            {(ArtistSummay?.length > 0) && <div className="verticalMediumWide hover-box">
                                <div className="ws-6 mtxl ptl mll pll hover-block textboxDropdownList box defaultColor rightReset mr">
                                    <div className="allowHscroll allowVscroll full-height-vh40">

                                        <div className="ws-12">
                                            <span className='ws-6 text-bold pb'>Top Artists</span>
                                            <span className='pull-right icon-btn edit btn-xs m0 p0 mr buttonLoad' id="TopArtist" onClick={() => downloadSummary("TopArtist")}>
                                                <i className="icon-download1 p1 m1"></i>
                                            </span>
                                        </div>
                                        <span className='ws-6 pull-left pb pt'>Artist Name</span>
                                        <span className='ws-3 pull-right pb pt'>Gross</span>
                                        <span className='ws-3 pull-right pb pt hide'>PaidOut</span>
                                        <div className="allowHscroll allowVscroll ws-12">
                                            {ArtistSummay?.map((value: any, index: any) => {
                                                return (
                                                    <div className='ws-12 box pm mb pull-right'>
                                                        <span className='ws-6 text-bold purple' > {value.assetArtist} </span>
                                                        <span className='pull-right' style={{ color: "green" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)}  {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)}</span>
                                                        <span className='ws-3 pull-right hide' style={{ color: "red" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)}  {value.totalPaidOut?.toFixed(2)} </span>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                        <div className="ws-12 pm">
                                            <span className='ws-4 pull-left pb pt'>Top {ArtistSummay?.[0]?.totalRows > 10 ? ArtistSummay?.length : ArtistSummay?.[0]?.totalRows} Total</span>
                                            <span className='ws-4 pull-right pb pt text-right' style={{ color: "green" }}>
                                                {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {totalArtist && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalArtist)}
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                <a className="icon-btn info pull-right pt noBorder"><i className="icon-info1 m0 p0"></i></a>
                            </div>}

                            <div className='ws-12 allowVscroll pLarge pts'>
                                <HorizontalBarChart chartPassedData={CallChart(ArtistSummay, "Artist")} />
                            </div>

                        </div>
                    </div>
                </div>}

                {<div className="ws-6 mbl p1 prl">
                    <h2 className={AssetSummay && AssetSummay?.length === 0 ? 'grey' : ''}>Top

                        {AssetSummay && AssetSummay[0] && AssetSummay[0]?.totalRows > 10 && <span className="p1 ml mr">
                            <select value={TopAssetSelection} onChange={(e: any) => pagsizeUpdate(e.target.value, "TopAsset")} className="dropDownListing p0 heightReset">
                                {options?.map((option: any) => (<option value={option}>{option}</option>))}
                            </select>
                        </span>}

                        {AssetSummay && AssetSummay[0] && AssetSummay[0]?.totalRows < 10 && <span> {AssetSummay[0]?.totalRows} </span>}
                        Assets</h2>
                    <div className='box ws-12 pt pbl'>
                        <div className='ws-12'>

                            {(AssetSummay?.length > 0) && <div className="verticalMediumWide hover-box">
                                <div className="ws-9 mtxl ptl mll pll hover-block textboxDropdownList box defaultColor rightReset mr">
                                    <div className="allowHscroll allowVscroll full-height-vh40">
                                        <div className="ws-12">
                                            <span className='ws-6 text-bold pb'>Top Assets</span>
                                            <span className='pull-right icon-btn edit btn-xs m0 p0 mr buttonLoad' id="TopAsset" onClick={() => downloadSummary("TopAsset")}>
                                                <i className="icon-download1 p1 m1"></i>
                                            </span>
                                        </div>
                                        <span className='ws-6 pull-left pb pt'>Asset Title</span>
                                        <span className='ws-2 pull-right pb pt'>Gross</span>
                                        <span className='ws-3 pull-right pb pt hide'>PaidOut</span>
                                        <div className="allowHscroll allowVscroll ws-12">
                                            {AssetSummay?.map((value: any, index: any) => {
                                                return (
                                                    <div className='ws-12 box pm mb pull-right'>
                                                        <span className='ws-6 text-bold purple' > {value.assetTitle} </span>
                                                        <span className='pull-right text-right' style={{ color: "green" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)}  </span>
                                                        <span className='ws-3 pull-right hide' style={{ color: "red" }}>   {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalPaidOut && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalPaidOut)} </span>
                                                    </div>
                                                )
                                            })}
                                        </div>


                                        <div className="ws-12 pm">
                                            <span className='ws-4 pull-left pb pt'>Top {AssetSummay?.[0]?.totalRows > 10 ? AssetSummay?.length : AssetSummay?.[0]?.totalRows} Total</span>
                                            <span className='ws-4 pull-right pb pt text-right' style={{ color: "green" }}>
                                                {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {totalAssets && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalAssets)}
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                <a className="icon-btn info pull-right pt noBorder"><i className="icon-info1 m0 p0"></i></a>
                            </div>}

                            <div className='ws-12 allowVscroll pLarge pts'>
                                <HorizontalBarChart chartPassedData={CallChart(AssetSummay, "Asset")} />
                            </div>

                        </div>
                    </div>
                </div>}

                {<div className="ws-6 mbl p1 prl">
                    <h2 className={TerritorySummay && TerritorySummay?.length === 0 ? 'grey' : ''}>Top

                        {TerritorySummay && TerritorySummay[0] && TerritorySummay[0]?.totalRows > 10 && <span className="p1 ml mr">
                            <select value={TopTerritorySelection} onChange={(e: any) => pagsizeUpdate(e.target.value, "TopTerritory")} className="dropDownListing p0 heightReset">
                                {options?.map((option: any) => (<option value={option}>{option}</option>))}
                            </select>
                        </span>}

                        {TerritorySummay && TerritorySummay[0] && TerritorySummay[0]?.totalRows < 10 && <span> {TerritorySummay[0]?.totalRows} </span>}
                        Territory</h2>
                    <div className='box ws-12 pt pbl'>
                        <div className='ws-12'>

                            {(TerritorySummay?.length > 0) && <div className="verticalMediumWide hover-box">
                                <div className="ws-8 mtxl ptl mll pll hover-block textboxDropdownList box defaultColor rightReset mr">
                                    <div className="allowHscroll allowVscroll full-height-vh40">
                                        <div className="ws-12">
                                            <span className='ws-6 text-bold pb'>Top Territory</span>
                                            <span className='pull-right icon-btn edit btn-xs m0 p0 mr buttonLoad' id="TopTerritory" onClick={() => downloadSummary("TopTerritory")}>
                                                <i className="icon-download1 p1 m1"></i>
                                            </span>
                                        </div>
                                        <span className='ws-6 pull-left pb pt'>Territory Code</span>
                                        <span className='ws-3 pull-right pb pt'>Gross</span>
                                        <span className='ws-3 pull-right pb pt hide'>PaidOut</span>
                                        <div className="allowHscroll allowVscroll ws-12">
                                            {TerritorySummay?.map((value: any, index: any) => {
                                                return (
                                                    <div className='ws-12 box pm mb pull-right'>
                                                        <span className='ws-6 text-bold purple' > {CommonUtilities?.lookUpTypeListByKey("Territory", value.territoryCode, 'value')} </span>
                                                        <span className='pull-right' style={{ color: "green" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)}</span>
                                                        <span className='ws-3 pull-right hide' style={{ color: "red" }}>   {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalPaidOut?.toFixed(2)} </span>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                        <div className="ws-12 pm">
                                            <span className='ws-4 pull-left pb pt'>Top {TerritorySummay?.[0]?.totalRows > 10 ? TerritorySummay?.length : TerritorySummay?.[0]?.totalRows} Total</span>
                                            <span className='ws-4 pull-right pb pt text-right' style={{ color: "green" }}>
                                                {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {totalTerritory && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalTerritory)}
                                            </span>
                                        </div>

                                    </div>

                                </div>

                                <a className="icon-btn info pull-right pt noBorder"><i className="icon-info1 m0 p0"></i></a>
                            </div>}

                            <div className='ws-12 allowVscroll pLarge pts'>
                                <HorizontalBarChart chartPassedData={CallChart(TerritorySummay, "Territory")} />
                            </div>

                        </div>
                    </div>
                </div>}

                {<div className="ws-6 mbl mbl p1 prl">
                    <h2 className={AssetSummay && AssetSummay?.length === 0 ? 'grey' : ''}>
                        Top
                        {FormatSummay && FormatSummay[0] && FormatSummay[0]?.totalRows > 10 && <span className="p1 ml mr">
                            <select value={TopFormatSelection} onChange={(e: any) => pagsizeUpdate(e.target.value, "TopFormat")} className="dropDownListing p0 heightReset">
                                {options?.map((option: any) => (<option value={option}>{option}</option>))}
                            </select>
                        </span>}

                        {FormatSummay && FormatSummay[0] && FormatSummay[0]?.totalRows < 10 && <span> {FormatSummay[0]?.totalRows}</span>}
                        Format
                    </h2>
                    <div className='box ws-12 pt pbl'>

                        <div className='ws-12'>

                            {(FormatSummay?.length > 0) && <div className="verticalMediumWide hover-box">
                                <div className="ws-8 mtxl ptl mll pll hover-block textboxDropdownList box defaultColor rightReset">
                                    <div className="allowHscroll allowVscroll full-height-vh40">

                                        <div className="ws-12">
                                            <span className='ws-6 text-bold pb'>Top Format</span>
                                            <span className='pull-right icon-btn edit btn-xs m0 p0 mr buttonLoad' id="TopFormat" onClick={() => downloadSummary("TopFormat")}>
                                                <i className="icon-download1 p1 m1"></i>
                                            </span>
                                        </div>

                                        <span className='ws-6 pull-left pb pt'>Format Code</span>
                                        <span className='ws-3 pull-right pb pt'>Gross</span>
                                        <span className='ws-3 pull-right pb pt hide'>PaidOut</span>
                                        {FormatSummay?.map((value: any, index: any) => {
                                            return (
                                                <div className='ws-12 box pm mb pull-right'>
                                                    <span className='ws-6 text-bold purple' > {CommonUtilities?.lookUpTypeListByKey("Format", value.formatCode, 'value')}</span>
                                                    <span className='pull-right' style={{ color: "green" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)} </span>
                                                    <span className='ws-3 pull-right hide' style={{ color: "red" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalPaidOut?.toFixed(2)} </span>
                                                </div>
                                            )
                                        })}
                                        <div className="ws-12 pm">
                                            <span className='ws-4 pull-left pb pt'>Top {FormatSummay?.[0]?.totalRows > 10 ? FormatSummay?.length : FormatSummay?.[0]?.totalRows} Total</span>
                                            <span className='ws-4 pull-right pb pt text-right' style={{ color: "green" }}>
                                                {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {totalFormats && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalFormats)}
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                <a className="icon-btn info pull-right pt noBorder"><i className="icon-info1 m0 p0"></i></a>
                            </div>}

                            <div className='ws-12 allowVscroll pLarge pts'>
                                <HorizontalBarChart chartPassedData={CallChart(FormatSummay, "Format")} />
                            </div>

                        </div>
                    </div>
                </div>}

                {<div className="ws-12 mbl mbl p1 prl">
                    <h2 className={AssetSummay && AssetSummay?.length === 0 ? 'grey' : ''}> Top

                        {ImprintSummay && ImprintSummay[0] && ImprintSummay[0]?.totalRows > 10 && <span className="p1 ml mr">
                            <select value={TopImprintSelection} onChange={(e: any) => pagsizeUpdate(e.target.value, "TopLabel")} className="dropDownListing p0 heightReset">
                                {options?.map((option: any) => (<option value={option}>{option}</option>))}
                            </select>
                        </span>}

                        {ImprintSummay && ImprintSummay[0] && ImprintSummay[0]?.totalRows < 10 && <span> {ImprintSummay[0].totalRows} </span>}
                        Imprint </h2>
                    <div className='box ws-12 pt pbl'>
                        <span className="ws-12 text-bold pb text-center"></span>

                        <div className='ws-12'>
                            {(ImprintSummay?.length > 0) && <div className="verticalMediumWide hover-box">
                                <div className="ws-5 mtxl ptl mll pll hover-block textboxDropdownList box defaultColor rightReset">
                                    <div className="allowHscroll allowVscroll full-height-vh40">

                                        <div className="ws-12">
                                            <span className='ws-6 text-bold pb'>Top Imprint</span>
                                            <span className='pull-right icon-btn edit btn-xs m0 p0 mr buttonLoad' id="TopLabel" onClick={() => downloadSummary("TopLabel")}>
                                                <i className="icon-download1 p1 m1"></i>
                                            </span>
                                        </div>

                                        <span className='ws-3 pull-right pb pt hide'>PaidOut</span>
                                        <span className='ws-3 pull-right pb pt'>Gross</span>
                                        {ImprintSummay?.map((value: any, index: any) => {
                                            return (
                                                <div className='ws-12 box pm mb pull-right'>
                                                    <span className='ws-6 text-bold'> {value.assetImprint} </span>
                                                    <span className='pull-right' style={{ color: "green" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalGross && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(value?.totalGross)} </span>
                                                    <span className='ws-3 pull-right hide' style={{ color: "red" }}> {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {value.totalPaidOut?.toFixed(2)} </span>
                                                </div>
                                            )
                                        })}

                                        <div className="ws-12 pm">
                                            <span className='ws-4 pull-left pb pt'>Top {ImprintSummay?.[0]?.totalRows > 10 ? ImprintSummay?.length : ImprintSummay?.[0]?.totalRows} Total</span>
                                            <span className='ws-4 pull-right pb pt text-right' style={{ color: "green" }}>
                                                {CommonUtilities?.getCSymbols(clientDetailList?.homeCurrency)} {totalImprints && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalImprints)}
                                            </span>
                                        </div>

                                    </div>
                                </div>

                                <a className="icon-btn info pull-right pt noBorder"><i className="icon-info1 m0 p0"></i></a>
                            </div>}

                            <div className='ws-12 pLarge'>
                                <HorizontalBarChart chartPassedData={CallChart(ImprintSummay, "Imprint")} />
                            </div>

                        </div>
                    </div>
                </div>}

            </div>
        </div>

        {(() => {
            if (periodSelection === true) {
                return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChange} periodFrom={Filter.convertToDateString(reportingFrom)} periodTo={Filter.convertToDateString(reportingTo)} />;
            }
            if (dialogueOpenView) {
                return (<ContainerSlider onChangeClose={onChangeClose} open={dialogueOpenView} selectedDetail={param.selectedDetail} type={param?.DAOpen} />)
            }
        })()}
    </>)
}